<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14Tm08x/tc-custom/9780857901149.jpg?1699984801781" alt="This image is the cover for the book Borders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Borders
      </h1>
      <p class="bookDescription body article font2">
        <b>A “beautifully written” history of the Scottish Borders—from the Ice Age to present day—by the author of <i>Scotland: A History from Earliest Times</i> (<i>Boston Sunday Herald</i>).</b><br/>  <br/> This is the story of the border: a place of beginnings and endings, of differences and similarities. It is the story of England and Scotland, told not from the remoteness of London or Edinburgh or in the tired terms of national histories, but up close and personal, toe to toe and eyeball to eyeball across the tweed, the Cheviots, the Esk, and the tidal races of the upper Solway. This is a tale told in blood, fun, and granite-hard memory. This is the story of an ancient place where hunter-gatherers penetrated into the virgin interior, where Celtic warlords ruled and the Romans came but could not conquer, where the glittering kingdom of Northumbria thrived, where David MacMalcolm raised great abbeys, and where Walter Scott sat at Abbotsford and brooded on the area’s rich and historic legacy.<br/>  <br/> “Highly readable—a lively, clear style.” —<i>Northern History</i><br/>  <br/> “Quirky, learned and utterly absorbing.” —Allan Massie, award-winning author of <i>The Royal Stuarts</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alistair Moffat
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Polygon
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?db310f62